module.exports = __webpack_public_path__ + "static/media/Webex.a7a8c3f0.jpg";